import React from "react";
import "../Components/Home/Design/index.css";

const ComingPage = () => {
  return (
    <div className="backgroundImage">
      <div className="img">
        <img src={"assets/Style/A.png"} alt="background" />
        <div>
          <h1>Website Under Development</h1>
        </div>
      </div>
    </div>
  );
};

export default ComingPage;
